import React, { act, useEffect, useState } from "react";
import { useAuth } from "../../../auth/FirebaseAuth.js";

import {
  createDoc,
  getFlutterTime,
  getFlutterTimeFromSeconds,
  getLocalStringFromFlutter,
  getRefFromId,
  queryCollection,
} from "../../../models/DataFunctions.js";
import SecondaryButton from "../../../buttons/SecondaryButton.js";

import { useAppContext } from "../../../config/AppContext.js";

import { useSnackbar } from "notistack";

import TextField2T from "../../../textfields/TextField2T.js";
import PrimaryButton from "../../../buttons/PrimaryButton.js";

import SmallSpinner from "../../../loading/SmallSpinner.js";
import NavBarButton from "../../../buttons/NavBarButton.js";
import { BlockNumer } from "../../home/MasterSmallStats.js";
import Icon1 from "../../../icons/Icon.js";
import TextFieldEmail from "../../../textfields/TextFieldEmail.js";
import DataGridGPT2 from "../../../tables/DataGridGPT2.js";
import { dbHexamails } from "../../../config/FirebaseConfig.js";
import { getDoc, updateDoc } from "firebase/firestore";
import Modal1 from "../../../modals/Modal1.js";
import { email_base } from "./hexamails_data.js";
import TabGPT from "../../../tabs/TabGPT.js";
import {
  BlockCampaign,
  BlockEmailTemplate,
  BlockStep,
  BlockStepCampaign,
  deleteDocHM,
  PrimaryButtonHexamails,
  updateDocHM,
} from "./Hexamails.js";
import WarningButton from "../../../buttons/WarningButton.js";

export function CampaignPage({ navigateWorkspace }) {
  const { currentUser, loading } = useAuth();

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const [userData, setUserData] = useState(null);
  const [tab, setTab] = useState("kpis");
  const [email_selected, setEmailSelected] = useState(null);
  const [campaign_selected, setCampaignSelected] = useState(null);
  const [active_campaign_selected, setActiveCampaignSelected] = useState(null);
  const [choose_email_for_campaign, setChooseEmailForCampaigns] =
    useState(false);
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [email_templates, setEmailTempaltes] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [active_campaigns, setActiveCampaigns] = useState([]);
  const [choose_user_open, setChooseUserOpen] = useState(false);
  const [masters, setMasters] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const [tab_campaign, setTabCampaign] = useState("campaign");

  const handleFetchData = async () => {
    let email_templates = await queryCollection(
      "email_template",
      [],
      100,
      null,
      null,
      dbHexamails
    );
    let campagins = await queryCollection(
      "campaign",
      [],
      100,
      null,
      null,
      dbHexamails
    );
    let active_campagins = await queryCollection(
      "active_campaign",
      [],
      100,
      null,
      null,
      dbHexamails
    );
    setEmailTempaltes(email_templates);
    setActiveCampaigns(active_campagins);
    setCampaigns(campagins);
  };

  const handleDeleteCampaign = async () => {
    if (
      window.confirm(
        "Êtes-vous sûr de vouloir supprimer cette campagne ? Cela supprimera également toutes les campagnes actives associées."
      )
    ) {
      setLoadingData(true);
      await deleteDocHM("campaign", campaign_selected.id);
      setCampaignSelected(null);
      setLoadingData(false);
      handleFetchData();
      handleClickVariant("Campagne supprimée", "success");
    }
  };

  const handleDeleteActiveCampaign = async () => {
    if (
      window.confirm(
        "Êtes-vous sûr de vouloir supprimer cette campagne active ?"
      )
    ) {
      setLoadingData(true);
      await deleteDocHM("active_campaign", active_campaign_selected.id);
      setActiveCampaignSelected(null);
      setLoadingData(false);
      handleFetchData();
      handleClickVariant("Campagne active supprimée", "success");
    }
  };

  const handleFetchUsers = async () => {
    let masters = await queryCollection("org", [
      {
        field: "facturation.plan",
        operator: "!=",
        value: "free",
      },
    ]);
    setMasters(masters);
  };
  const createDocHM = async (collection, data) => {
    let res = await createDoc(collection, data, dbHexamails);
    return res;
  };

  const getDocHm = async (collection, id) => {
    let ref = getRefFromId(collection, id, dbHexamails);
    let res = await getDoc(ref);
    return res;
  };

  const [loadingData, setLoadingData] = useState(false);

  const handleCreateNewCampaign = async () => {
    setLoadingData(true);
    let new_doc = await createDocHM("campaign", {
      title: "Nouvelle campagne",
      steps: [],
    });
    console.log("new doc", new_doc);
    setCampaignSelected(new_doc);
    setLoadingData(false);
    handleFetchData();
  };
  const handleCreateActiveCampaignForOrg = async (org) => {
    setLoadingData(true);
    await createDocHM("active_campaign", {
      title: campaign_selected.title,
      org_email: org.email,
      org_id: org.id,
      campaign_id: campaign_selected.id,
      state: "paused",
      current_step: 0,
      steps: campaign_selected.steps.map((step) => ({
        email_template_id: step.email_template_id,
        days_delay: step.days_delay,
        state: "pending",
      })),
    });
    setLoadingData(false);
    setChooseUserOpen(false);
    handleFetchData();
  };

  const handleUpdateActiveCampaignSteps = async () => {
    setLoadingData(true);
    // we need to not lose the state of the steps that are already sent or clicked
    // so only add new steps or update the days_delay of existing steps that are still pending
    // and remove steps that are not in the campaign anymore

    let preservedSteps = active_campaign_selected.steps.filter(
      (step) => step.state !== "pending"
    );

    let updatedCampaignSteps = campaign_selected.steps.map((step) => {
      let existing_step = active_campaign_selected.steps.find(
        (s) => s.email_template_id === step.email_template_id
      );
      if (existing_step) {
        if (existing_step.state === "pending") {
          return {
            ...existing_step,
            days_delay: step.days_delay,
          };
        } else {
          return existing_step;
        }
      } else {
        return {
          email_template_id: step.email_template_id,
          days_delay: step.days_delay,
          state: "pending",
        };
      }
    });

    let updated_steps = [...preservedSteps, ...updatedCampaignSteps].filter(
      (step, index, arr) =>
        arr.findIndex((s) => s.email_template_id === step.email_template_id) ===
        index
    );

    let new_active_campaign = {
      ...active_campaign_selected,
      steps: updated_steps,
    };
    await updateDocHM(
      "active_campaign",
      active_campaign_selected.id,
      new_active_campaign
    );

    setLoadingData(false);
    handleClickVariant("Étapes mises à jour", "success");
    handleFetchData();
    setActiveCampaignSelected(new_active_campaign);
  };

  const handleSaveCampaign = async () => {
    setLoadingData(true);
    await updateDocHM("campaign", campaign_selected.id, campaign_selected);
    handleClickVariant("Campagne sauvegardée", "success");
    setLoadingData(false);
    handleFetchData();
  };
  const handleSaveActiveCampaign = async (new_active_campaign = null) => {
    let active_campaign = new_active_campaign
      ? new_active_campaign
      : active_campaign_selected;
    setLoadingData(true);
    await updateDocHM("active_campaign", active_campaign.id, active_campaign);
    handleClickVariant("Campagne active sauvegardée", "success");
    setLoadingData(false);
    handleFetchData();
  };
  // Fetch data when the component mounts or when currentUser changes
  useEffect(() => {
    setCampaignSelected(null);
    setEmailSelected(null);
    handleFetchData();
  }, [tab]);

  // If the data is still loading or the user is not authenticated, show a loading message
  if (loading || !currentUser) {
    return <SmallSpinner></SmallSpinner>;
  }

  // Render the client data
  return (
    <>
      {campaign_selected ? (
        <div className="flex flex-col gap-4">
          <div className="flex flex-row justify-between">
            <div className="text-h1 font-bold text-shadow_50">
              {campaign_selected?.title}
            </div>
            <SecondaryButton
              className={"w-fit h-fit"}
              onClick={() => setCampaignSelected(null)}
            >
              Fermer
            </SecondaryButton>
          </div>
          <TabGPT
            tabs={[
              { id: "campaign", label: "Etapes de la campagne" },
              { id: "users", label: "Utilisateurs programmés" },
            ]}
            setActiveTab={setTabCampaign}
            activeTab={tab_campaign}
          ></TabGPT>
          {tab_campaign === "campaign" ? (
            <>
              <div className="flex flex-col max-w-c700 border-1 rounded-lg ">
                <div className="text-h3 font-bold p-2 border-b-1 flex flex-row justify-between">
                  <TextField2T
                    noborder={true}
                    value={campaign_selected.title}
                    onChange={(e) =>
                      setCampaignSelected({
                        ...campaign_selected,
                        title: e.target.value,
                      })
                    }
                  ></TextField2T>
                </div>
                <div className="text-h5 flex flex-col gap-1 font-normal bg-neutral-50 overflow-auto max-h-c700 p-4">
                  {campaign_selected.steps.map((step, index) => (
                    <div key={index}>
                      {email_templates
                        .filter((e) => e.id === step.email_template_id)
                        .sort((a, b) => a.object.localeCompare(b.object))
                        .map((e, index) => (
                          <div key={index}>
                            <BlockStepCampaign
                              title={e.object}
                              delay={step.days_delay}
                              step={step}
                              onClickUp={() =>
                                setCampaignSelected({
                                  ...campaign_selected,
                                  steps: campaign_selected.steps.map((s) =>
                                    s.email_template_id === e.id
                                      ? {
                                          ...s,
                                          days_delay: s.days_delay + 1,
                                        }
                                      : s
                                  ),
                                })
                              }
                              onClickDown={() =>
                                setCampaignSelected({
                                  ...campaign_selected,
                                  steps: campaign_selected.steps.map((s) =>
                                    s.email_template_id === e.id
                                      ? {
                                          ...s,
                                          days_delay: s.days_delay - 1,
                                        }
                                      : s
                                  ),
                                })
                              }
                              onClickDelete={() =>
                                setCampaignSelected({
                                  ...campaign_selected,
                                  steps: campaign_selected.steps.filter(
                                    (s) => s.email_template_id !== e.id
                                  ),
                                })
                              }
                            ></BlockStepCampaign>
                          </div>
                        ))}
                    </div>
                  ))}
                  <PrimaryButtonHexamails
                    startIcon={
                      <Icon1 icon_name="plus" width="18px" fill="white"></Icon1>
                    }
                    className="mt-2"
                    onClick={() =>
                      setChooseEmailForCampaigns(!choose_email_for_campaign)
                    }
                  >
                    {choose_email_for_campaign ? "Annuler " : "Ajouter"}
                  </PrimaryButtonHexamails>
                  {choose_email_for_campaign && (
                    <Modal1
                      isOpen={choose_email_for_campaign}
                      onClose={() => setChooseEmailForCampaigns(false)}
                    >
                      <div className="flex flex-col gap-1 bg-white p-4 max-h-c500 overflow-auto rounded-lg">
                        {email_templates
                          .filter(
                            (et) =>
                              !campaign_selected.steps

                                .map((s) => s.email_template_id)
                                .includes(et.id)
                          )
                          .sort((a, b) => a.object.localeCompare(b.object))

                          .map((email, index) => (
                            <div key={index}>
                              <BlockCampaign
                                onClick={() => {
                                  setChooseEmailForCampaigns(false);
                                  setCampaignSelected({
                                    ...campaign_selected,
                                    steps: campaign_selected.steps.concat([
                                      {
                                        email_template_id: email.id,
                                        days_delay: 1,
                                      },
                                    ]),
                                  });
                                }}
                                title={email.object}
                                number="243"
                                icon="email"
                              />
                            </div>
                          ))}
                      </div>
                    </Modal1>
                  )}
                </div>{" "}
                <div className="flex flex-row justify-between  gap-4 p-4 border-t-1">
                  <WarningButton onClick={() => handleDeleteCampaign()}>
                    Supprimer
                  </WarningButton>
                  <PrimaryButtonHexamails onClick={() => handleSaveCampaign()}>
                    Enregistrer la campagne{" "}
                    {loadingData && <SmallSpinner></SmallSpinner>}
                  </PrimaryButtonHexamails>
                </div>
              </div>
            </>
          ) : (
            <>
              {active_campaign_selected ? (
                <>
                  <>
                    <div className="flex flex-col max-w-c700 border-1 rounded-lg ">
                      <div className="flex flex-row text-h3 p-4 border-b-1 gap-2 justify-between">
                        {active_campaign_selected.org_email}
                        <SecondaryButton
                          className={"w-fit ml-auto"}
                          onClick={() => setActiveCampaignSelected(null)}
                        >
                          Fermer
                        </SecondaryButton>
                        <PrimaryButtonHexamails
                          onClick={() => {
                            let new_active_campaign = {
                              ...active_campaign_selected,
                              state:
                                active_campaign_selected.state === "active"
                                  ? "paused"
                                  : "active",
                              activation_date:
                                active_campaign_selected.state === "active"
                                  ? null
                                  : getFlutterTime(),
                              paused_date:
                                active_campaign_selected.state === "active"
                                  ? getFlutterTime()
                                  : null,
                            };
                            handleSaveActiveCampaign(new_active_campaign);
                            setActiveCampaignSelected(new_active_campaign);
                          }}
                          startIcon={
                            <Icon1
                              icon_name={
                                active_campaign_selected.state === "active"
                                  ? "horloge"
                                  : "send"
                              }
                              fill={"white"}
                            ></Icon1>
                          }
                        >
                          {active_campaign_selected.state === "active"
                            ? "Mettre en pause"
                            : "Réactiver la campagne"}
                          {loadingData && <SmallSpinner></SmallSpinner>}
                        </PrimaryButtonHexamails>
                      </div>
                      <div className="text-h5 flex flex-col gap-1 font-normal bg-neutral-50 overflow-auto max-h-c700 p-4">
                        <div className="text-shadow_50 text-h3 p-2">
                          Date d'activation :{" "}
                          {getLocalStringFromFlutter(
                            active_campaign_selected.activation_date
                          )}
                          {"  ID : "}
                          {active_campaign_selected.id}
                        </div>

                        {
                          // if any step in model is not present in the active campaign

                          campaign_selected.steps.some(
                            (step) =>
                              !active_campaign_selected.steps.find(
                                (s) =>
                                  s.email_template_id === step.email_template_id
                              )
                          ) && (
                            <div className="text-red-500 text-h3 p-2 mb-6 bg-red-50 border-1 border-red-200 rounded-lg flex flex-row gap-2 items-center">
                              Attention : Les étapes de cette campagne active ne
                              correspondent pas à celles de la campagne modèle.
                              <PrimaryButtonHexamails
                                onClick={() =>
                                  handleUpdateActiveCampaignSteps()
                                }
                              >
                                Mettre à jour
                              </PrimaryButtonHexamails>
                            </div>
                          )
                        }

                        {active_campaign_selected.steps.map((step, index) => (
                          <div key={index}>
                            {email_templates
                              .filter((e) => e.id === step.email_template_id)
                              .sort((a, b) => a.object.localeCompare(b.object))
                              .map((e, index) => (
                                <div key={index}>
                                  <BlockStep
                                    icon_name={
                                      step.state === "sent"
                                        ? "send"
                                        : step.state === "clicked"
                                          ? "open"
                                          : "horloge"
                                    }
                                    title={e.object}
                                    email_template_id={e.id}
                                    delay={step.days_delay}
                                    trigger_date={calcuateTriggerDate(
                                      step,
                                      active_campaign_selected
                                    )}
                                    step={step}
                                    onClickUp={() =>
                                      setActiveCampaignSelected({
                                        ...active_campaign_selected,
                                        steps:
                                          active_campaign_selected.steps.map(
                                            (s) =>
                                              s.email_template_id === e.id
                                                ? {
                                                    ...s,
                                                    days_delay:
                                                      s.days_delay + 1,
                                                  }
                                                : s
                                          ),
                                      })
                                    }
                                    onClickDown={() =>
                                      setActiveCampaignSelected({
                                        ...active_campaign_selected,
                                        steps:
                                          active_campaign_selected.steps.map(
                                            (s) =>
                                              s.email_template_id === e.id
                                                ? {
                                                    ...s,
                                                    days_delay:
                                                      s.days_delay - 1,
                                                  }
                                                : s
                                          ),
                                      })
                                    }
                                    onClickDelete={() =>
                                      setActiveCampaignSelected({
                                        ...active_campaign_selected,
                                        steps:
                                          active_campaign_selected.steps.filter(
                                            (s) => s.email_template_id !== e.id
                                          ),
                                      })
                                    }
                                  ></BlockStep>
                                </div>
                              ))}
                          </div>
                        ))}
                        <PrimaryButtonHexamails
                          startIcon={
                            <Icon1
                              icon_name="plus"
                              width="18px"
                              fill="white"
                            ></Icon1>
                          }
                          className="mt-2"
                          onClick={() =>
                            setChooseEmailForCampaigns(
                              !choose_email_for_campaign
                            )
                          }
                        >
                          {choose_email_for_campaign ? "Annuler " : "Ajouter"}
                        </PrimaryButtonHexamails>
                        {choose_email_for_campaign && (
                          <Modal1
                            isOpen={choose_email_for_campaign}
                            onClose={() => setChooseEmailForCampaigns(false)}
                          >
                            <div className="flex flex-col gap-1 bg-white p-4 max-h-c500 overflow-auto rounded-lg">
                              {email_templates
                                .sort((a, b) =>
                                  a.object.localeCompare(b.object)
                                )
                                .map((email, index) => (
                                  <div key={index}>
                                    <BlockCampaign
                                      onClick={() => {
                                        setChooseEmailForCampaigns(false);
                                        setActiveCampaignSelected({
                                          ...active_campaign_selected,
                                          steps:
                                            active_campaign_selected.steps.concat(
                                              [
                                                {
                                                  email_template_id: email.id,
                                                  days_delay: 1,
                                                  state: "pending",
                                                },
                                              ]
                                            ),
                                        });
                                      }}
                                      title={email.object}
                                      number="243"
                                      icon="email"
                                    />
                                  </div>
                                ))}
                            </div>
                          </Modal1>
                        )}
                      </div>{" "}
                      <div className="flex flex-row justify-between  gap-4 p-4 border-t-1">
                        <WarningButton
                          onClick={() => handleDeleteActiveCampaign()}
                        >
                          Supprimer
                        </WarningButton>{" "}
                        <PrimaryButtonHexamails
                          onClick={() => handleSaveActiveCampaign()}
                        >
                          Enregistrer la campagne active{" "}
                          {loadingData && <SmallSpinner></SmallSpinner>}
                        </PrimaryButtonHexamails>
                      </div>
                    </div>
                  </>
                </>
              ) : (
                <>
                  {" "}
                  {choose_user_open && (
                    <Modal1
                      isOpen={choose_user_open}
                      onClose={() => setChooseUserOpen(false)}
                    >
                      <div className="flex flex-col gap-1 bg-white p-4 max-h-c500 overflow-auto rounded-lg">
                        {masters.map((org, index) => (
                          <div key={index}>
                            <BlockCampaign
                              onClick={() =>
                                handleCreateActiveCampaignForOrg(org)
                              }
                              title={org.email}
                              number="243"
                              icon="email"
                            />
                          </div>
                        ))}
                      </div>
                    </Modal1>
                  )}
                  <div className="flex flex-col max-w-c700 border-1 rounded-lg ">
                    <div className="flex flex-row justify-between items-center  border-b-1">
                      <div className="text-h3 font-bold p-4">
                        Utilisateurs programmés
                      </div>{" "}
                      <PrimaryButtonHexamails
                        onClick={() => {
                          handleFetchUsers();
                          setChooseUserOpen(true);
                        }}
                      >
                        Ajouter un utilisateur
                        {loadingData && <SmallSpinner></SmallSpinner>}
                      </PrimaryButtonHexamails>
                    </div>
                    <div className="text-h5 flex flex-col gap-1 font-normal bg-neutral-50 overflow-auto max-h-c700 p-4">
                      {active_campaigns.map((campaign) => (
                        <BlockEmailTemplate
                          title={campaign.org_email}
                          number_1={campaign.steps.length}
                          number_2={Math.round(
                            (campaign.steps.filter((s) => s.state !== "pending")
                              .length /
                              (campaign.steps.length || 1)) *
                              100
                          )}
                          number_3={Math.round(
                            (campaign.steps.filter((s) => s.state === "clicked")
                              .length /
                              (campaign.steps.filter(
                                (s) => s.state !== "pending"
                              ).length || 1)) *
                              100
                          )}
                          sufix="%"
                          icon={
                            campaign.state === "active"
                              ? "horloge"
                              : campaign.state === "completed"
                                ? "done"
                                : "send"
                          }
                          border_color={
                            campaign.state === "active"
                              ? "border-indigo-500"
                              : campaign.state === "completed"
                                ? "border-green-400"
                                : "border-orange-300"
                          }
                          onClick={() => {
                            setActiveCampaignSelected(campaign);
                          }}
                        />
                      ))}
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      ) : (
        <div className="flex flex-col gap-2">
          <PrimaryButtonHexamails
            onClick={() => handleCreateNewCampaign()}
            startIcon={
              <Icon1 icon_name="plus" width="18px" fill="white"></Icon1>
            }
            className="mb-4"
          >
            Nouvelle campagne {loadingData && <SmallSpinner></SmallSpinner>}
          </PrimaryButtonHexamails>
          <div className="flex flex-col gap-1">
            {" "}
            {campaigns.map((campaign) => (
              <BlockCampaign
                title={campaign.title}
                number={campaign.steps.length}
                icon="send"
                onClick={() => setCampaignSelected(campaign)}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
}

export const calcuateTriggerDate = (step, active_campaign) => {
  if (!active_campaign.activation_date || active_campaign.state !== "active") {
    return "Non activée";
  }

  // we need to calculate the trigger date based on the activation date and the days_delay of all previous steps

  // only take into account steps that either don't have a sent_at date or have a sent_at date in the future
  // this way if a step is sent late it doesn't impact the trigger date of the next steps

  let relevant_steps = active_campaign.steps;

  let step_index = relevant_steps.findIndex(
    (s) => s.email_template_id === step.email_template_id
  );
  if (step_index === -1) return null;

  let total_days_delay = 0;
  for (let i = 0; i <= step_index; i++) {
    total_days_delay += relevant_steps[i].days_delay || 0;
  }
  console.log("total_days_delay", active_campaign.org_email, total_days_delay);

  let activation_date = active_campaign.activation_date;
  // set hour to 7am
  let date = new Date(activation_date.seconds * 1000);
  date.setHours(7, 0, 0, 0);
  let new_activation_date = {
    seconds: Math.floor(date.getTime() / 1000),
  };

  let trigger_seconds = new_activation_date.seconds + total_days_delay * 86400;
  let trigger_date = getFlutterTimeFromSeconds(trigger_seconds);
  return getLocalStringFromFlutter(trigger_date);
};
